define.alias("shared/components/shared/social/connect-profile", "media/components/shared/social/connect-profile");